export const pluginId = 'graphql';
